import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval } from 'rxjs';

// Also used by IdleTimeoutService as the lead time before the actual lease expiry at
// which this dialog is shown - keep both durations in sync.
export const WARNING_DURATION_SECONDS = 30;

@Component({
  imports: [MatDialogModule, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './idle-warning-dialog.component.html',
})
export class IdleWarningDialogComponent implements OnInit {
  private dialogRef = inject(MatDialogRef<IdleWarningDialogComponent>);
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);

  remainingSeconds = WARNING_DURATION_SECONDS;

  ngOnInit(): void {
    interval(1000)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.remainingSeconds--;
        this.cdr.markForCheck();

        if (this.remainingSeconds <= 0) {
          this.dialogRef.close(false);
        }
      });
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
